import { User as AuthUser } from "firebase/auth";
import StorageUtil from "../../utils/storage";
import { createSlice } from "@reduxjs/toolkit";

type Theme = "dark" | "light";
interface AppState {
  ready: boolean;
  theme: Theme;
  authUser: AuthUser | null;
}

const theme = StorageUtil.get<Theme>("loa-theme") || "light";
document.documentElement.setAttribute("data-theme", theme);

const initialState: AppState = {
  ready: false,
  theme,
  authUser: null,
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    ready: (state) => {
      state.ready = true;
    },
    theme: (state, action) => {
      state.theme = action.payload;
      StorageUtil.set("loa-theme", action.payload);
      document.documentElement.setAttribute("data-theme", action.payload);
    },
    setAuthUser: (state, action) => {
      state.authUser = action.payload;
    },
  },
});

export const appActions = appSlice.actions;
export default appSlice.reducer;
